import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import PdfQTypeActivity from "../../On_going/Published/Published_Q_list/PublishQuestionType/PdfType/PdfQTypeActivity";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../axios";
import StudentTableActivityReview from "./Table_Props/StudentTableActivityReview";
import CompletedASList from "../../On_going/Published/Published_Q_list/CompletedASList";
import { Popup } from "semantic-ui-react";
import PendingStudentPopup from "./Table_Props/PendingStudentPopup";
import PendingSPopup from "./Table_Props/PendingSPopup";
import { Award } from "lucide-react";

const ReviewStudentListActivity = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [pendingPopup, setPendingPopup] = useState(false);
  const [pendingPopup1, setPendingPopup1] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [disable, setDisable] = useState(true);
  const [click, setClick] = useState();
  const [display, setDisplay] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [showDetails, setShowDetails] = useState(true);

  const [loading, setLoading] = useState(false);
  const [noResults, setNoResults] = useState(false);

  const [reviewData, setReviewData] = useState({
    reviewActivitys: [],
    reviewSList: [],
    completedSList: [],
  });

  const { reviewActivitys, reviewSList, completedSList } = reviewData;

  console.log(reviewActivitys, "reviewActivitys");

  // Helper function to render grade/marks info
  const renderGradeOrMarksInfo = () => {
    const entryType = reviewActivitys?.entryType;
    const totalMarks = reviewActivitys?.total_marks;
    const gradeScale = reviewActivitys?.gradeScaleId;
    // If entryType is "Marks", show total marks
    if (entryType === "Marks") {
      return (
        <div className="d-flex align-items-center gap-2">
          <span
            style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}
          >
            Total Marks
          </span>
          <span
            style={{ fontSize: "1.1rem", fontWeight: 700, color: "#0f172a" }}
          >
            {totalMarks || 0}
          </span>
          <span
            className="badge"
            style={{
              backgroundColor: "#28a745",
              color: "#fff",
              fontSize: "10px",
            }}
          >
            Marks
          </span>
        </div>
      );
    }

    // If entryType is "Grade", show grade scale info
    if (entryType === "Grade" && gradeScale) {
      return (
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <Award size={16} style={{ color: "#6366f1" }} />
          <span
            style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}
          >
            Grade Scale:
          </span>
          <span
            style={{ fontSize: "0.9rem", fontWeight: 700, color: "#4338ca" }}
          >
            {gradeScale.name}
          </span>
          <span
            className="badge"
            style={{
              backgroundColor: "#6366f1",
              color: "#fff",
              fontSize: "10px",
            }}
          >
            Grade
          </span>
          <div className="d-flex gap-1 flex-wrap">
            {gradeScale.grades?.map((grade) => (
              <span
                key={grade.grade}
                className="badge"
                style={{
                  backgroundColor:
                    grade.resultStatus === "Pass" ? "#d4edda" : "#f8d7da",
                  color: grade.resultStatus === "Pass" ? "#155724" : "#721c24",
                  padding: "3px 8px",
                  borderRadius: "4px",
                  fontSize: "10px",
                  fontWeight: 600,
                }}
              >
                {grade.grade}: {grade.minMarks}-{grade.maxMarks}
              </span>
            ))}
          </div>
        </div>
      );
    }

    return null;
  };

  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedSearch(filterName.trim());
    }, 500);
    return () => clearTimeout(t);
  }, [filterName]);

  useEffect(() => {
    reviewSList.forEach((obj) => {
      if (obj.status === "review") {
        setDisable(true);
      } else if (obj.status === "pending") {
        setPendingPopup(true);
      } else {
        setDisable(false);
      }
    });
  }, [reviewSList]);

  useEffect(() => {
    const helper = () => {
      reviewSList.map((obj) => {
        if (obj.status === "pending") {
          setPendingPopup1(false);
        } else {
          setPendingPopup1(false);
        }
      });
    };
    helper();
  }, [reviewSList]);

  useEffect(() => {
    const getReviewActivity = async () => {
      setLoading(true);
      setNoResults(false);

      try {
        const res = await axios.get(
          `/api/v1/homework/activity/getById/${state.reviewActivity_id}`,
        );

        const reviewSListRes = await axios.get(
          `/api/v1/homework/studentActivity/getByAcivityId/${state.reviewActivity_id}?name=${debouncedSearch}`,
        );

        const completed1 = await axios.get(
          `/api/v1/homework/studentActivity/getByAcivityId/${state.reviewActivity_id}?status=review`,
        );

        const completed2 = await axios.get(
          `/api/v1/homework/studentActivity/getByAcivityId/${state.reviewActivity_id}?status=completed`,
        );

        const students = reviewSListRes.data.data;

        if (!students || students.length === 0) {
          setReviewData({
            reviewActivitys: res.data.data,
            reviewSList: [],
            completedSList: [...completed1.data.data, ...completed2.data.data],
          });
          setNoResults(true);
        } else {
          setNoResults(false);
          setReviewData({
            reviewActivitys: res.data.data,
            reviewSList: students,
            completedSList: [...completed1.data.data, ...completed2.data.data],
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    getReviewActivity();
  }, [debouncedSearch]);

  const handleStatus = async () => {
    let changeStatus = { status: "completed" };

    try {
      const res = await axios.post(
        `/api/v1/homework/activity/updateStatus/${state.reviewActivity_id}`,
        changeStatus,
      );
      res && navigate("/PublishedHomeworkActivity");
    } catch (error) {
      console.log(error);
    }
    setSubmitted(true);
  };

  const helper1 = () => {
    if (pendingPopup === true) {
      setDisplay(true);
    } else {
      handleStatus();
    }
  };

  const myList = [completedSList];
  const totalLength = myList
    .map((array) => array.length)
    .reduce((sum, length) => sum + length, 0);

  return (
    <>
      {/* ═══════════════════════════════════════════════════
          MAIN CONTENT — no outer scroll lock
          ═══════════════════════════════════════════════════ */}
      <div
        className="orange-scrollBar"
        style={{
          width: "100%",
          maxHeight: "calc(100vh - 120px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {/* ── Header ── */}
        <div className="d-flex align-items-center gap-3 w-100 mb-3">
          <div
            onClick={() => navigate("/PublishedHomeworkActivity")}
            style={{
              cursor: "pointer",
              width: "36px",
              height: "36px",
              borderRadius: "10px",
              background: "#f1f5f9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <img
              src="/images/Back Arrow.svg"
              alt="Back"
              style={{ width: "18px" }}
            />
          </div>

          <div className="d-flex flex-column gap-1" style={{ flex: 1 }}>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                style={{
                  fontSize: "1.25rem",
                  fontWeight: 700,
                  color: "#1e293b",
                  lineHeight: 1.3,
                }}
              >
                {reviewActivitys?.name || "Activity"}
              </span>
              <span
                style={{
                  background: "#fff7ed",
                  color: "#c2410c",
                  border: "1px solid #fed7aa",
                  padding: "4px 12px",
                  borderRadius: "999px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                  whiteSpace: "nowrap",
                }}
              >
                On Review
              </span>
            </div>
            <span className="fw-small text-muted" style={{ fontSize: "11px" }}>
              Dashboard / Assignment / Activity / On review /{" "}
              {reviewActivitys?.name}
            </span>
          </div>

          {/* 🆕 Grade/Marks Info Box - Replaces Total Marks */}
          <div
            className="d-flex align-items-center gap-3"
            style={{
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              padding: "8px 16px",
              borderRadius: "10px",
              whiteSpace: "nowrap",
            }}
          >
            {renderGradeOrMarksInfo()}
          </div>
        </div>

        {/* ── Activity Details Card ── */}
        <div
          style={{
            backgroundColor: "#f8f9fa",
            border: "1px solid #e9ecef",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          {/* Collapsible Description */}
          <div
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: "16px",
              overflow: "hidden",
              background: "#ffffff",
              boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
            }}
          >
            {/* Description Header */}
            <div
              onClick={() => setShowDetails(!showDetails)}
              className="d-flex justify-content-between align-items-center px-3 py-3 flex-wrap gap-2"
              style={{
                cursor: "pointer",
                background: "linear-gradient(135deg, #fff7ed 0%, #fef3c7 100%)",
              }}
            >
              <div className="d-flex flex-column gap-2">
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <span
                    style={{
                      background: "#fff",
                      padding: "6px 14px",
                      borderRadius: "999px",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#92400e",
                      border: "1px solid #fde68a",
                    }}
                  >
                    📘 {reviewActivitys?.subject_id?.name}
                  </span>
                  <span
                    style={{
                      background: "#fff",
                      padding: "6px 14px",
                      borderRadius: "999px",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#7c2d12",
                      border: "1px solid #fed7aa",
                    }}
                  >
                    ⏰ Deadline:{" "}
                    {reviewActivitys?.deadline
                      ? new Date(reviewActivitys.deadline).toLocaleDateString()
                      : "--"}
                  </span>

                  {/* 🆕 Entry Type Badge in Description */}
                  {reviewActivitys?.entryType &&
                    reviewActivitys?.entryType !== "None" && (
                      <span
                        style={{
                          background:
                            reviewActivitys?.entryType === "Grade"
                              ? "#6366f1"
                              : "#28a745",
                          color: "#fff",
                          padding: "4px 12px",
                          borderRadius: "999px",
                          fontSize: "11px",
                          fontWeight: 600,
                        }}
                      >
                        {reviewActivitys?.entryType}
                      </span>
                    )}
                </div>
                <div>
                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: 700,
                      color: "#92400e",
                    }}
                  >
                    📝 Activity Description
                  </span>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#78716c",
                      marginTop: "2px",
                    }}
                  >
                    Click to {showDetails ? "hide" : "view"} full description
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#92400e",
                  flexShrink: 0,
                  userSelect: "none",
                }}
              >
                {showDetails ? "−" : "+"}
              </div>
            </div>

            {/* Description Body */}
            <div
              style={{
                maxHeight: showDetails ? "300px" : "0px",
                overflow: "hidden",
                transition: "all 0.35s ease",
              }}
            >
              <div
                className="Published_Activity_text orange-scrollBar"
                style={{
                  width: "100%",
                  padding: "18px",
                  whiteSpace: "pre-wrap",
                  lineHeight: 1.7,
                  color: "#475569",
                  fontSize: "14px",
                  maxHeight: "260px",
                  overflowY: "auto",
                }}
              >
                {reviewActivitys?.description || "No description available"}
              </div>
            </div>
          </div>

          {/* Lab Card */}
          {reviewActivitys?.activity_type === "Lab" &&
            reviewActivitys?.lab_ref && (
              <div className="mt-4 mb-2">
                <div
                  className="p-3"
                  style={{
                    backgroundColor: "#fff7ed",
                    border: "2px solid #f97316",
                    borderRadius: "16px",
                  }}
                >
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    <img
                      src={reviewActivitys.lab_ref.thumbnailUrl}
                      alt={reviewActivitys.lab_ref.title}
                      style={{
                        width: "130px",
                        height: "85px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        border: "1px solid #fdba74",
                        flexShrink: 0,
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                        <span
                          style={{
                            fontWeight: 700,
                            color: "#c2410c",
                            fontSize: "1.05rem",
                          }}
                        >
                          {reviewActivitys.lab_ref.title}
                        </span>
                        <span
                          className="badge rounded-pill"
                          style={{
                            backgroundColor: "#ffedd5",
                            color: "#c2410c",
                            fontSize: "0.75rem",
                            padding: "6px 10px",
                          }}
                        >
                          {reviewActivitys.lab_ref.resourceType}
                        </span>
                      </div>
                      <p
                        style={{
                          color: "#7c2d12",
                          fontSize: "0.85rem",
                          lineHeight: 1.5,
                          marginBottom: "8px",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {reviewActivitys.lab_ref.description}
                      </p>
                      <span style={{ fontSize: "0.8rem", color: "#9a3412" }}>
                        {reviewActivitys.lab_ref.estimatedDurationMinutes} mins
                      </span>
                    </div>
                    <button
                      className="btn"
                      style={{
                        backgroundColor: "#f97316",
                        color: "#ffffff",
                        borderRadius: "10px",
                        padding: "8px 20px",
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        border: "none",
                        whiteSpace: "nowrap",
                      }}
                      onClick={() => {
                        const previewData = {
                          selectedLab: reviewActivitys.lab_ref,
                          activityData: {
                            title: reviewActivitys.name,
                            description: reviewActivitys.description,
                            className: reviewActivitys?.standard_id?.name,
                            subjectName: reviewActivitys?.subject_id?.name,
                            chapterName:
                              reviewActivitys?.chapter_id?.chapterName || "",
                            duration: reviewActivitys?.duration || "20 minutes",
                          },
                        };

                        localStorage.setItem(
                          "activityPreviewData",
                          JSON.stringify(previewData),
                        );

                        const features = [
                          "toolbar=no",
                          "location=no",
                          "directories=no",
                          "status=no",
                          "menubar=no",
                          "scrollbars=yes",
                          "resizable=yes",
                          "fullscreen=yes",
                          `width=${window.screen.availWidth}`,
                          `height=${window.screen.availHeight}`,
                          "top=0",
                          "left=0",
                        ].join(",");

                        const newWindow = window.open(
                          "/activity-lab-preview.html",
                          "_blank",
                          features,
                        );

                        if (newWindow) {
                          newWindow.moveTo(0, 0);
                          newWindow.resizeTo(
                            window.screen.availWidth,
                            window.screen.availHeight,
                          );
                          newWindow.focus();
                        }
                      }}
                    >
                      Open Activity
                    </button>
                  </div>
                </div>
              </div>
            )}

          {/* PDF Attachments */}
          <div className="mt-4 pdf_container_activity_review">
            {reviewActivitys?.attachments?.length !== 0 &&
              reviewActivitys?.attachments?.map((attachments, idx) => (
                <PdfQTypeActivity
                  key={idx}
                  publishedAttachData={reviewActivitys}
                  attachments={attachments}
                />
              ))}
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════
            STUDENT LIST CARD — SCROLL + POPUP + LOADER FIXED
            ═══════════════════════════════════════════════════ */}
        <div
          className="d-flex flex-column"
          style={{
            backgroundColor: "white",
            width: "100%",
            borderRadius: "12px",
            border: "1px solid #e9ecef",
            overflow: "hidden",
          }}
        >
          {/* Top Bar */}
          <div className="px-3 py-3 d-flex align-items-center justify-content-between flex-wrap gap-3">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                style={{
                  background: "#fff7ed",
                  color: "#c2410c",
                  border: "1px solid #fed7aa",
                  padding: "4px 12px",
                  borderRadius: "999px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                  whiteSpace: "nowrap",
                }}
              >
                On Review
              </span>
              <span
                className="published_hw_header_subject_name"
                style={{ fontWeight: 600, color: "#475569" }}
              >
                {reviewActivitys?.subject_id?.name}
              </span>

              {/* POPUP FIXED: better position, scrollable content wrapper */}
              <Popup
                open={click}
                onClose={() => setClick(false)}
                on="click"
                wide="very"
                position="bottom center"
                className="completed_list"
                trigger={
                  <div
                    className="mx-2 activity_status_box d-flex align-items-center"
                    style={{ zIndex: 20 }}
                  >
                    <img
                      src="/images/memberListIcon.png"
                      className="second"
                      alt=""
                      onClick={() => setClick(true)}
                      style={{
                        width: "37px",
                        height: "36px",
                        borderRadius: "50%",
                        border: "1px solid gray",
                      }}
                    />
                    <span
                      className="nth_personsp d-flex align-items-center justify-content-center"
                      onClick={() => setClick(true)}
                    >
                      {totalLength}
                    </span>
                  </div>
                }
                content={
                  <div
                    style={{
                      maxHeight: "320px",
                      overflowY: "auto",
                      minWidth: "240px",
                      padding: "8px",
                    }}
                  >
                    <CompletedASList
                      completeList={completedSList}
                      setClick={setClick}
                    />
                  </div>
                }
                hideOnScroll
              />
            </div>

            <div className="d-flex align-items-center gap-3 flex-wrap">
              <div style={{ position: "relative", width: "260px" }}>
                <input
                  className="form-control mr-sm-2 m-0 name_search_box"
                  type="search"
                  placeholder="Search by Student Name"
                  aria-label="Search"
                  onChange={(e) => setFilterName(e.target.value)}
                  style={{
                    borderRadius: "10px",
                    border: "1px solid #e2e8f0",
                    paddingLeft: "36px",
                    fontSize: "0.85rem",
                  }}
                />
                <img
                  className="name_search_icon"
                  src="/images/search icon.svg"
                  alt=""
                  style={{
                    position: "absolute",
                    left: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "16px",
                  }}
                />
              </div>

              <button
                className="px-3 py-2 submit_result22 rounded-2"
                onClick={helper1}
                type="submit"
                disabled={disable}
                style={{
                  opacity: disable ? 0.6 : 1,
                  cursor: disable ? "not-allowed" : "pointer",
                }}
              >
                Submit
              </button>
            </div>
          </div>

          {/* Table — Scrollable Area (FIXED) */}
          <div
            className="orange-scrollBar"
            style={{
              overflow: "auto",
              maxHeight: "calc(100vh - 360px)",
              minHeight: "180px",
              borderTop: "1px solid #f1f5f9",
              position: "relative",
            }}
          >
            <Table
              responsive
              className="student_profile_table"
              borderless
              style={{ textAlign: "center", marginBottom: 0 }}
            >
              <thead style={{ position: "sticky", top: 0 }}>
                <tr>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Name
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Roll No.
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Class
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Division
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Date submitted
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    {reviewActivitys?.entryType === "Marks"
                      ? "Marks"
                      : "Grades"}
                  </th>
                  <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                    Status
                  </th>
                </tr>
              </thead>

              <tbody>
                {/* INLINE LOADER — no full screen overlay */}
                {loading && reviewSList.length === 0 && (
                  <tr>
                    <td
                      colSpan="7"
                      style={{ padding: "50px 20px", textAlign: "center" }}
                    >
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <img
                          src="/gif/LoaderDot.gif"
                          alt="loading"
                          style={{ height: "50px" }}
                        />
                        <div
                          className="mt-2 text-muted"
                          style={{ fontSize: "13px" }}
                        >
                          Loading students...
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

                {/* EMPTY STATE */}
                {!loading && noResults && (
                  <tr>
                    <td
                      colSpan="7"
                      style={{ padding: "50px 20px", textAlign: "center" }}
                    >
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <img
                          src="/images/no-data.png"
                          alt="No data"
                          style={{ width: "80px", opacity: 0.6 }}
                          onError={(e) => (e.target.style.display = "none")}
                        />
                        <div className="mt-3 fw-bold text-muted">
                          No student found
                        </div>
                        <div
                          className="text-muted"
                          style={{ fontSize: "12px", marginTop: "4px" }}
                        >
                          Try searching with a different name.
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

                {/* DATA ROWS - Pass entryType and gradeScaleId to child */}
                {!loading &&
                  !noResults &&
                  reviewSList.map((reviewSLData) => (
                    <StudentTableActivityReview
                      key={reviewSLData?._id || reviewSLData?.id}
                      reviewSLData={reviewSLData}
                      reviewActivitys={reviewActivitys}
                      reviewActivity_id={state?.reviewActivity_id}
                      setPendingPopup1={setPendingPopup1}
                      // 🔥 Pass entryType and gradeScaleId to child
                      entryType={reviewActivitys?.entryType}
                      gradeScaleId={reviewActivitys?.gradeScaleId}
                    />
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      {submitted}
      {pendingPopup1 && <PendingSPopup setPendingPopup1={setPendingPopup1} />}
      {display && (
        <PendingStudentPopup
          setPendingPopup={setDisplay}
          reviewActivity_id={state?.reviewActivity_id}
        />
      )}
    </>
  );
};

export default ReviewStudentListActivity;
